export default {
  // speech core states
  speechInstance: null,
  availableVoices: [],
  paused: false,
  reading: false,

  // playlist states
  playlist: JSON.parse(localStorage.getItem('playlist')) || [], // JSON.parse(localStorage.getItem('playlist')) || [], // content : [{subtitle:.., text: ..}]
  currentIndex: Number(localStorage.getItem('track')) || -1, // index of the current track
  currentText: '', // the sentence reading at the moment, used by paragraph and subtitles
  markerSpeech: JSON.parse(localStorage.getItem('speech')) || null // marker of the current speech
}
